import Fingerprint2 from 'fingerprintjs2';
import axios from 'axios';
import config from '@/config';

const noop = () => {};

const getFileFormData = (file) => {
  const formData = new FormData();

  formData.append('file', file, file.name);

  return formData;
};

const getFingerprint = () => new Promise((resolve) => {
  Fingerprint2.getV18(resolve);
});

export default class ApiService {
  static async getEntries({ appId }) {
    const url = `${config.apiUrl}/entries/public?contestId=${appId}`;

    const options = {
      method: 'get',
    };

    return fetch(url, options)
      .then(response => response.json());
  }

  static async createEntry({ data, attachment, appId }) {
    const NO_DATA = 'NO_DATA';
    const entriesUrl = `${config.apiUrl}/entries/rodo`;

    const {
      childFirstName, childLastName, firstName, lastName, email, phone,
      legals,
    } = data;

    const fingerprint = await getFingerprint();

    const parsedData = {
      firstName,
      lastName,
      childFirstName,
      childLastName,
      email,
      phone,
      street: NO_DATA,
      city: NO_DATA,
      zip: NO_DATA,

      contestId: appId,
      fingerprint,

      result: {
        answer: NO_DATA,
        attachment,
      },

      legals,
    };

    const options = {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(parsedData),
    };

    const response = await fetch(entriesUrl, options);

    return response.json();
  }

  static async uploadFile(file, onUploadProgress = noop) {
    const formData = getFileFormData(file);

    return axios.post(config.storageUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    }).then(({ data: filename }) => `${config.storageUrl}/${filename}`);
  }
}
